export default __webpack_public_path__ + "static/media/illus06.5c0926e9.png";